var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("travel-service-menu"),
      _c("h2", [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t(
                "settings.travelService.additionalSettings.availableServiceTypes"
              )
            ) +
            " "
        )
      ]),
      _c("v-checkbox", {
        attrs: {
          label: _vm.$t(
            "settings.travelService.additionalSettings.flightInsurance"
          )
        },
        model: {
          value: _vm.model.travel_service_flight_available,
          callback: function($$v) {
            _vm.$set(_vm.model, "travel_service_flight_available", $$v)
          },
          expression: "model.travel_service_flight_available"
        }
      }),
      _c("v-checkbox", {
        attrs: {
          label: _vm.$t(
            "settings.travelService.additionalSettings.hotelInsurance"
          )
        },
        model: {
          value: _vm.model.travel_service_hotel_available,
          callback: function($$v) {
            _vm.$set(_vm.model, "travel_service_hotel_available", $$v)
          },
          expression: "model.travel_service_hotel_available"
        }
      }),
      _c("v-checkbox", {
        attrs: {
          label: _vm.$t(
            "settings.travelService.additionalSettings.railInsurance"
          )
        },
        model: {
          value: _vm.model.travel_service_rail_available,
          callback: function($$v) {
            _vm.$set(_vm.model, "travel_service_rail_available", $$v)
          },
          expression: "model.travel_service_rail_available"
        }
      }),
      _c("v-checkbox", {
        attrs: {
          label: _vm.$t(
            "settings.travelService.additionalSettings.carInsurance"
          )
        },
        model: {
          value: _vm.model.travel_service_car_available,
          callback: function($$v) {
            _vm.$set(_vm.model, "travel_service_car_available", $$v)
          },
          expression: "model.travel_service_car_available"
        }
      }),
      _c(
        "fieldset",
        { staticClass: "custom-fieldset" },
        [
          _c("legend", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "settings.travelService.additionalSettings.standardOptionsFlight"
                )
              )
            )
          ]),
          _c("v-checkbox", {
            attrs: {
              label: _vm.$t("travelService.registeredBaggageWillBeAssigned")
            },
            model: {
              value: _vm.model.registered_baggage_will_be_assigned,
              callback: function($$v) {
                _vm.$set(_vm.model, "registered_baggage_will_be_assigned", $$v)
              },
              expression: "model.registered_baggage_will_be_assigned"
            }
          }),
          _c("v-checkbox", {
            attrs: { label: _vm.$t("travelService.isReturnRoute") },
            model: {
              value: _vm.model.flight_is_return_route,
              callback: function($$v) {
                _vm.$set(_vm.model, "flight_is_return_route", $$v)
              },
              expression: "model.flight_is_return_route"
            }
          })
        ],
        1
      ),
      _c(
        "fieldset",
        { staticClass: "custom-fieldset" },
        [
          _c("legend", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "settings.travelService.additionalSettings.standardOptionsHotels"
                )
              )
            )
          ]),
          _c("v-checkbox", {
            attrs: { label: _vm.$t("global.breakfast") },
            model: {
              value: _vm.model.is_breakfast_required,
              callback: function($$v) {
                _vm.$set(_vm.model, "is_breakfast_required", $$v)
              },
              expression: "model.is_breakfast_required"
            }
          }),
          _c("v-checkbox", {
            attrs: { label: _vm.$t("travelService.isParkingRequired") },
            model: {
              value: _vm.model.is_parking_required,
              callback: function($$v) {
                _vm.$set(_vm.model, "is_parking_required", $$v)
              },
              expression: "model.is_parking_required"
            }
          }),
          _c("v-checkbox", {
            attrs: {
              label: _vm.$t("travelService.isFreeCancellationRequired")
            },
            model: {
              value: _vm.model.is_free_cancellation_required,
              callback: function($$v) {
                _vm.$set(_vm.model, "is_free_cancellation_required", $$v)
              },
              expression: "model.is_free_cancellation_required"
            }
          })
        ],
        1
      ),
      _c(
        "fieldset",
        { staticClass: "custom-fieldset" },
        [
          _c("legend", [_vm._v(_vm._s(_vm.$t("travelService.insurance")))]),
          _c("v-row", [
            _c(
              "div",
              { staticClass: "pa-3 insurance-icon" },
              [
                _c("v-icon", { attrs: { "x-large": "", color: "primary" } }, [
                  _vm._v("fa-plane")
                ])
              ],
              1
            ),
            _c(
              "div",
              [
                _c("span", { staticClass: "insurance-label" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.forFlights")))
                ]),
                _c(
                  "v-radio-group",
                  {
                    attrs: { row: "" },
                    model: {
                      value: _vm.model.travel_service_flight_insurance,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.model,
                          "travel_service_flight_insurance",
                          $$v
                        )
                      },
                      expression: "model.travel_service_flight_insurance"
                    }
                  },
                  _vm._l(_vm.insuranceOptions, function(insuranceOption) {
                    return _c("v-radio", {
                      key: insuranceOption.value,
                      attrs: {
                        label: insuranceOption.text,
                        value: insuranceOption.value
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _c("v-row", [
            _c(
              "div",
              { staticClass: "pa-3 insurance-icon" },
              [
                _c("v-icon", { attrs: { "x-large": "", color: "primary" } }, [
                  _vm._v("fa-hotel")
                ])
              ],
              1
            ),
            _c(
              "div",
              [
                _c("span", { staticClass: "insurance-label" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.forHotels")))
                ]),
                _c(
                  "v-radio-group",
                  {
                    attrs: { row: "" },
                    model: {
                      value: _vm.model.travel_service_hotel_insurance,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.model,
                          "travel_service_hotel_insurance",
                          $$v
                        )
                      },
                      expression: "model.travel_service_hotel_insurance"
                    }
                  },
                  _vm._l(_vm.insuranceOptions, function(insuranceOption) {
                    return _c("v-radio", {
                      key: insuranceOption.value,
                      attrs: {
                        label: insuranceOption.text,
                        value: insuranceOption.value
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _c("v-row", [
            _c(
              "div",
              { staticClass: "pa-3 insurance-icon" },
              [
                _c("v-icon", { attrs: { "x-large": "", color: "primary" } }, [
                  _vm._v("fa-train")
                ])
              ],
              1
            ),
            _c(
              "div",
              [
                _c("span", { staticClass: "insurance-label" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.forRails")))
                ]),
                _c(
                  "v-radio-group",
                  {
                    attrs: { row: "" },
                    model: {
                      value: _vm.model.travel_service_rail_insurance,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.model,
                          "travel_service_rail_insurance",
                          $$v
                        )
                      },
                      expression: "model.travel_service_rail_insurance"
                    }
                  },
                  _vm._l(_vm.insuranceOptions, function(insuranceOption) {
                    return _c("v-radio", {
                      key: insuranceOption.value,
                      attrs: {
                        label: insuranceOption.text,
                        value: insuranceOption.value
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _c("v-row", [
            _c(
              "div",
              { staticClass: "pa-3 insurance-icon" },
              [
                _c("v-icon", { attrs: { "x-large": "", color: "primary" } }, [
                  _vm._v("fa-car")
                ])
              ],
              1
            ),
            _c(
              "div",
              [
                _c("span", { staticClass: "insurance-label" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.forCars")))
                ]),
                _c(
                  "v-radio-group",
                  {
                    attrs: { row: "" },
                    model: {
                      value: _vm.model.travel_service_car_insurance,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "travel_service_car_insurance", $$v)
                      },
                      expression: "model.travel_service_car_insurance"
                    }
                  },
                  _vm._l(_vm.insuranceOptions, function(insuranceOption) {
                    return _c("v-radio", {
                      key: insuranceOption.value,
                      attrs: {
                        label: insuranceOption.text,
                        value: insuranceOption.value
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("v-select", {
        attrs: {
          label: _vm.$t("travelService.changesAcceptanceLabel"),
          items: _vm.changeAcceptanceOptions
        },
        model: {
          value: _vm.model.travel_service_offer_changes_behavior,
          callback: function($$v) {
            _vm.$set(_vm.model, "travel_service_offer_changes_behavior", $$v)
          },
          expression: "model.travel_service_offer_changes_behavior"
        }
      }),
      _c("v-btn", { staticClass: "accent", on: { click: _vm.saveSettings } }, [
        _vm._v(_vm._s(_vm.$t("global.save")))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }